"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosisCodeList = void 0;
const list_1 = require("client/components/list");
const button_1 = require("client/components/material/button");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const store_2 = require("../../inventory/modules/inventory-detail/store");
require("./diagnosis-list.less");
let DiagnosisCodeList = class DiagnosisCodeList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.orderBy = "site";
    }
    renderListRow(row, index) {
        return (React.createElement("div", { className: "diagnosis-list-component__row", key: index },
            React.createElement("div", null, store_1.usersStore.permissions.UpdateFormulary && (React.createElement(button_1.MaterialButton, { className: "button-red", secondary: true, onClick: e => store_2.inventoryDetailStore.removeIcd10FromList(index) }, "Remove"))),
            React.createElement("div", { className: "diagnosis-list-component__column--profile" },
                React.createElement("div", { className: "value" }, row.value || row.Code)),
            React.createElement("div", { className: "diagnosis-list-component__column" },
                React.createElement("div", { className: "value" }, row.label || row.CodeDescription)),
            React.createElement("div", { className: "diagnosis-list-component__column--actions" })));
    }
    render() {
        const data = this.props.rowData;
        return (React.createElement("div", { className: "list" },
            store_2.inventoryDetailStore.icd10sList.length !== 0 && (React.createElement("div", { className: "settings__column-titles" },
                React.createElement("div", { className: "settings__column-titles-label label-1" }, "Diagnosis Code"),
                React.createElement("div", { className: "settings__column-titles-label label-2" }, "Description"))),
            React.createElement(list_1.List, { data: data, renderRow: this.renderListRow })));
    }
};
__decorate([
    mobx_1.observable
], DiagnosisCodeList.prototype, "orderBy", void 0);
DiagnosisCodeList = __decorate([
    mobx_react_1.observer
], DiagnosisCodeList);
exports.DiagnosisCodeList = DiagnosisCodeList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/diagnosis-list/diagnosis-list.tsx
// module id = 3474
// module chunks = 0